import CheckboxComponent from "./CheckBox";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Button as AIMEButton } from "tot-loft-component-library";
import ReCAPTCHA from "react-google-recaptcha";
import AccountSuccessModal from "./AccountSuccessModal";
import { PaartnerLogo } from "./assets";
import GenericModal from "./GenericModal";
import ModalSignupreferrerindiviualone from "./ModalSignupreferrerindiviualone";
import ModalSignupreferrerindiviualthree from "./ModalSignupreferrerindiviualthree";
import { addMemberItem } from "./redux/slices/MembersThunks";
import SignupSetupPayment from "./signupSetupPayment";
import Spinner from "./Spinner";
import { scrollToTop, convertToE164Format } from "./utils/func";
import {
  validateRequiredFields,
  validateAccountSetupFields,
} from "./utils/validation";
import {
  trackSignupPageView,
  trackFormInteraction,
  trackSignupFormSubmit,
} from "./utils/analytics";
import MemberTypeSelector from "./components/Signup/MemberTypeSelector";
import PersonalInfoForm from "./components/Signup/PersonalInfoForm";
import EnterpriseInfoForm from "./components/Signup/EnterpriseInfoForm";
import {
  RootWrapperSignupReferrerIndiviual,
  Header,
  HeaderWrapper,
  Left,
  Logo,
  Section,
  Wrapper,
  SignupSignin,
  ContentBlock1,
  Content,
  EarningCashForMakingReferralsIsEasierThanEver,
  DiscoverPaartnerSTrustedAlliesReadyToHelpYourFriendsWithTheServicesAndMarTechTheyNeedToSucceed,
  Frame58,
  Frame61,
  Frame60,
  ErrorMessage,
  Optional,
  ReCAPTCHAWrapper,
} from "./components/Signup/styles";

export default function Signup() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const referralCode = queryParams.get("ref");
  const stepParam = queryParams.get("step");

  const [selected, setSelected] = useState("individual");
  const [checked, setChecked] = useState(false);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email_address: "",
    phone_number: "",
    job_title: "",
    seniority: "",
    city: "",
    country_of_residence: "United Kingdom",
    password: "",
    member_type: "Individual",
    company_name: "",
    company_website_url: "",
    company_address: "",
    company_no: "",
    tax_identification_no: "",
    is_uk_registered: null,
    unique_taxpayer_reference_utr: "",
    profile_status: "Active",
    accountHolderName: "",
    accountNumber: "",
    confirmAccountNumber: "",
    ifscSwiftCode: "",
    dateOfBirth: "",
    streetAddress: "",
    postalCode: "",
    nationalInsuranceNumber: "",
    referral_code: referralCode || null,
  });

  const [agreeToMarketing, setAgreeToMarketing] = useState(false);
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [generalError, setGeneralError] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [openDuplicateEmailModal, setOpenDuplicateEmailModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showAccountSetup, setShowAccountSetup] = useState(
    stepParam === "account-setup"
  );
  const [setupNow, setSetupNow] = useState(false);
  const [setupLater, setSetupLater] = useState(true);
  const [recaptchaToken, setRecaptchaToken] = useState(null);

  const streetAddressRef = useRef();
  const postalCodeRef = useRef();
  const recaptchaRef = useRef(null);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    setGeneralError("");
    setFieldErrors((prev) => ({ ...prev, [field]: "" }));
    trackFormInteraction();
  };

  const handleSelectMemberType = (memberType) => {
    setSelected(memberType);
    setFormData({
      ...formData,
      member_type: memberType === "individual" ? "Individual" : "Enterprise",
    });
    setGeneralError("");
    setFieldErrors({});
  };

  const buildPayload = (
    formData,
    selected,
    recaptchaToken,
    agreeToMarketing,
    updatedFormData
  ) => {
    if (selected === "enterprise") {
      return {
        first_name: formData.first_name,
        last_name: formData.last_name,
        email_address: formData.email_address,
        phone_number: convertToE164Format(formData.phone_number),
        job_title: formData.job_title,
        seniority: formData.seniority,
        city: formData.city,
        country_of_residence: formData.country_of_residence,
        password: formData.password,
        member_type: formData.member_type,
        profile_status: "Active",
        agree_to_marketing: agreeToMarketing,
        company_name: formData.company_name,
        company_website_url: formData.company_website_url,
        company_address: formData.company_address,
        company_no: formData.company_no,
        tax_identification_no: formData.tax_identification_no,
        is_uk_registered: formData.is_uk_registered,
        unique_taxpayer_reference_utr: formData.unique_taxpayer_reference_utr,
        stripe_setup_skipped: true,
        referral_code: formData.referral_code,
        recaptcha_token: recaptchaToken,
      };
    } else {
      const [day, month, year] = formData.dateOfBirth.split("/");
      return {
        first_name: formData.first_name,
        last_name: formData.last_name,
        email_address: formData.email_address,
        phone_number: convertToE164Format(formData.phone_number),
        job_title: formData.job_title,
        seniority: formData.seniority,
        city: formData.city,
        country_of_residence: formData.country_of_residence,
        password: formData.password,
        member_type: formData.member_type,
        profile_status: "Active",
        agree_to_marketing: agreeToMarketing,
        referral_code: formData.referral_code,
        stripeAccountDetails: {
          account_holder_name: formData.accountHolderName,
          account_number: formData.accountNumber,
          confirm_account_number: formData.confirmAccountNumber,
          sort_code: formData.ifscSwiftCode,
          date_of_birth: {
            day: parseInt(day, 10),
            month: parseInt(month, 10),
            year: parseInt(year, 10),
          },
          home_address: updatedFormData.streetAddress,
          postal_code: updatedFormData.postalCode,
          nino: formData.nationalInsuranceNumber,
          recaptcha_token: recaptchaToken,
        },
      };
    }
  };

  const handleSubmissionResponse = (res, start) => {
    if (res.payload?.message === "Email already exists") {
      setOpenDuplicateEmailModal(true);
      trackSignupFormSubmit(
        selected,
        formData.referral_code,
        formData,
        performance.now() - start
      );
    } else if (res.payload?._id) {
      setOpenSuccessModal(true);
      trackSignupFormSubmit(
        selected,
        formData.referral_code,
        formData,
        performance.now() - start
      );
    } else if (res?.error) {
      const errorMsg =
        res.payload?.message ||
        res.error?.message ||
        "Registration failed. Please try again.";
      setGeneralError(errorMsg);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      setGeneralError(
        res.payload?.message ||
          "An unexpected error occurred. Please try again."
      );
    }
  };

  const handleSubmit = async () => {
    setHasSubmitted(true);
    setGeneralError("");

    const streetValue =
      streetAddressRef.current?.value || formData.streetAddress;
    const postalValue = postalCodeRef.current?.value || formData.postalCode;

    const updatedFormData = {
      ...formData,
      streetAddress: streetValue,
      postalCode: postalValue,
    };

    setFormData(updatedFormData);
    const start = performance.now();

    try {
      let isValid;
      let errors = {};

      if (!showAccountSetup) {
        errors = validateRequiredFields(formData, selected);
        isValid = Object.keys(errors).length === 0;
      } else {
        const result = validateAccountSetupFields(
          formData,
          streetAddressRef,
          postalCodeRef
        );
        errors = result.errors;
        isValid = Object.keys(errors).length === 0;
        if (isValid) {
          setFormData(result.updatedFormData);
        }
      }

      setFieldErrors(errors);

      if (!isValid) {
        return;
      }

      if (showAccountSetup && !recaptchaToken) {
        setGeneralError("Please complete the reCAPTCHA verification.");
        return;
      }

      if (
        !showAccountSetup &&
        setupLater &&
        selected === "individual" &&
        !recaptchaToken
      ) {
        setGeneralError("Please complete the reCAPTCHA verification.");
        return;
      }

      if (selected === "enterprise" && !recaptchaToken) {
        setGeneralError("Please complete the reCAPTCHA verification.");
        return;
      }

      if (!showAccountSetup && !checked) {
        setGeneralError(
          "You must agree to the Terms & Conditions and Privacy Policy."
        );
        return;
      }

      setIsSubmitting(true);

      if (!showAccountSetup && selected === "individual") {
        setShowAccountSetup(true);
        setHasSubmitted(false);
        setIsSubmitting(false);

        setRecaptchaToken(null);
        if (recaptchaRef.current) {
          recaptchaRef.current.reset();
        }

        const newParams = new URLSearchParams(location.search);
        newParams.set("step", "account-setup");
        navigate(`/signup?${newParams.toString()}`);
        scrollToTop();
        return;
      }

      const payload = buildPayload(
        formData,
        selected,
        recaptchaToken,
        agreeToMarketing,
        updatedFormData
      );
      const res = await dispatch(addMemberItem(payload));
      handleSubmissionResponse(res, start);
    } catch (error) {
      console.error("Signup error:", error);
      setGeneralError(
        error.message || "Something went wrong. Please try again."
      );
      window.scrollTo({ top: 0, behavior: "smooth" });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSkip = async () => {
    setHasSubmitted(true);
    setGeneralError("");
    const start = performance.now();

    try {
      const errors = validateRequiredFields(formData, selected);
      const isValid = Object.keys(errors).length === 0;
      setFieldErrors(errors);

      if (!isValid) {
        return;
      }

      if (!recaptchaToken) {
        setGeneralError("Please complete the reCAPTCHA verification.");
        return;
      }

      if (!checked) {
        setGeneralError(
          "You must agree to the Terms & Conditions and Privacy Policy."
        );
        return;
      }

      setIsSubmitting(true);

      const signupPayload = {
        first_name: formData.first_name,
        last_name: formData.last_name,
        email_address: formData.email_address,
        phone_number: convertToE164Format(formData.phone_number),
        job_title: formData.job_title,
        seniority: formData.seniority,
        city: formData.city,
        country_of_residence: formData.country_of_residence,
        password: formData.password,
        member_type: formData.member_type,
        profile_status: "Active",
        agree_to_marketing: agreeToMarketing,
        referral_code: formData.referral_code,
        stripe_setup_skipped: true,
        recaptcha_token: recaptchaToken,
      };

      const res = await dispatch(addMemberItem(signupPayload));
      handleSubmissionResponse(res, start);
    } catch (error) {
      console.error("Skip signup error:", error);
      setGeneralError(
        error.message || "Something went wrong. Please try again."
      );
      window.scrollTo({ top: 0, behavior: "smooth" });
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const step = params.get("step");

    if (step === "account-setup") {
      setShowAccountSetup(true);
    } else {
      setShowAccountSetup(false);
    }
  }, [location.search]);

  useEffect(() => {
    trackSignupPageView();
  }, []);

  const isStaging = process.env.REACT_APP_ENV === "staging";

  return (
    <RootWrapperSignupReferrerIndiviual>
      <Header>
        <HeaderWrapper>
          <Left>
            <Logo
              onClick={() => navigate("/")}
              src={PaartnerLogo}
              alt="Paartner Logo"
            />
          </Left>
          {isStaging && (
            <div
              style={{
                color: "red",
                padding: "10px",
                textAlign: "center",
                fontWeight: "bold",
              }}
            >
              🔴 STAGING ENVIRONMENT
            </div>
          )}
        </HeaderWrapper>
      </Header>

      {!showAccountSetup ? (
        <Section id="signup-form">
          <Wrapper>
            <SignupSignin>
              <ContentBlock1>
                <Content>
                  <EarningCashForMakingReferralsIsEasierThanEver>
                    Join Paartner
                  </EarningCashForMakingReferralsIsEasierThanEver>
                  <DiscoverPaartnerSTrustedAlliesReadyToHelpYourFriendsWithTheServicesAndMarTechTheyNeedToSucceed>
                    Sign-up as an individual or enterprise member and get
                    rewarded for advocating for the hottest marketing agencies,
                    AI tools and MarTech. In cash. You wise owl you!
                  </DiscoverPaartnerSTrustedAlliesReadyToHelpYourFriendsWithTheServicesAndMarTechTheyNeedToSucceed>
                </Content>
              </ContentBlock1>

              <Frame58>
                <PersonalInfoForm
                  formData={formData}
                  hasSubmitted={hasSubmitted}
                  fieldErrors={fieldErrors}
                  handleInputChange={handleInputChange}
                />
                <MemberTypeSelector
                  selected={selected}
                  onSelectMemberType={handleSelectMemberType}
                />

                {selected === "enterprise" && (
                  <EnterpriseInfoForm
                    formData={formData}
                    setFormData={setFormData}
                    hasSubmitted={hasSubmitted}
                    fieldErrors={fieldErrors}
                    handleInputChange={handleInputChange}
                    setGeneralError={setGeneralError}
                    setFieldErrors={setFieldErrors}
                  />
                )}

                {selected === "enterprise" && (
                  <CheckboxComponent
                    label="I agree to receiving marketing emails from Paartner promoting the latest rewards available to me (we will never sell your data)."
                    checked={agreeToMarketing}
                    onChange={(e) => setAgreeToMarketing(e.target.checked)}
                  />
                )}

                <Frame61>
                  <Frame60>
                    <CheckboxComponent
                      label={
                        <span>
                          I agree to the{" "}
                          <span
                            onClick={(e) => {
                              e.stopPropagation();
                              openModal();
                            }}
                            style={{
                              color: "rgba(97, 98, 197, 1)",
                              cursor: "pointer",
                            }}
                          >
                            Terms & Conditions
                          </span>{" "}
                          and{" "}
                          <span style={{ color: "rgba(97, 98, 197, 1)" }}>
                            Privacy Policy
                          </span>
                          .
                        </span>
                      }
                      checked={checked}
                      onChange={() => {
                        setChecked(!checked);
                      }}
                    />
                  </Frame60>
                </Frame61>

                {selected === "enterprise" && (
                  <ReCAPTCHAWrapper>
                    <ReCAPTCHA
                      ref={recaptchaRef}
                      sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                      onChange={(token) => setRecaptchaToken(token)}
                      onExpired={() => setRecaptchaToken(null)}
                    />
                  </ReCAPTCHAWrapper>
                )}

                {selected !== "enterprise" && (
                  <>
                    <div
                      style={{
                        marginTop: "16px",
                        fontSize: "14px",
                        lineHeight: "160%",
                        color: "rgb(33,37,67)",
                        fontFamily: "Montserrat, sans-serif",
                      }}
                    >
                      <Optional>
                        Optional: Set up bank details to receive rewards
                      </Optional>
                      <p style={{ marginTop: "4px" }}>
                        If you prefer to complete this step later, that's
                        absolutely fine. However, please be aware that there may
                        be a brief delay in processing your rewards while we
                        complete the necessary KYC (Know Your Customer)
                        verification.
                      </p>
                    </div>
                    <Frame60 style={{ marginTop: "12px" }}>
                      <CheckboxComponent
                        label="I'd prefer to do this later"
                        checked={setupLater}
                        onChange={() => {
                          setSetupLater(!setupLater);
                          setSetupNow(false);
                        }}
                      />
                    </Frame60>

                    <Frame60>
                      <CheckboxComponent
                        label="Yes, I would like to set up bank details now"
                        checked={setupNow}
                        onChange={() => {
                          setSetupNow(!setupNow);
                          setSetupLater(false);
                        }}
                      />
                    </Frame60>

                    {setupLater && (
                      <ReCAPTCHAWrapper>
                        <ReCAPTCHA
                          ref={recaptchaRef}
                          sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                          onChange={(token) => setRecaptchaToken(token)}
                          onExpired={() => setRecaptchaToken(null)}
                        />
                      </ReCAPTCHAWrapper>
                    )}
                  </>
                )}

                {generalError && (
                  <ErrorMessage style={{ marginBottom: "16px" }}>
                    {generalError}
                  </ErrorMessage>
                )}

                <AIMEButton
                  size="small"
                  onClick={() => {
                    if (selected === "enterprise") {
                      handleSubmit();
                    } else {
                      setupLater ? handleSkip() : handleSubmit();
                    }
                  }}
                  disabled={isSubmitting}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "row",
                    alignItems: "center",
                    flex: "none",
                    gap: "10px",
                    borderRadius: "48px",
                    width: "320px",
                    background: isSubmitting
                      ? "rgba(132, 137, 146, 1)"
                      : "rgb(33, 37, 67)",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    boxSizing: "border-box",
                    padding: "16px 32px",
                    "&:hover": {
                      background: isSubmitting
                        ? "rgba(132, 137, 146, 1)"
                        : "rgb(33, 37, 67)",
                      opacity: isSubmitting ? "1" : "0.9",
                    },
                    "&:disabled": {
                      background: "rgba(132, 137, 146, 1)",
                      opacity: "1",
                      cursor: "not-allowed",
                    },
                    "@media (max-width: 768px)": {
                      width: "260px",
                    },
                    "@media (max-width: 480px)": {
                      width: "100%",
                    },
                  }}
                >
                  <span
                    style={{
                      color: "white",
                      textOverflow: "ellipsis",
                      fontSize: "16px",
                      fontFamily: "Montserrat, sans-serif",
                      fontWeight: "600",
                      lineHeight: "110%",
                      textAlign: "left",
                    }}
                  >
                    {isSubmitting ? <Spinner /> : "Continue"}
                  </span>
                </AIMEButton>
              </Frame58>
            </SignupSignin>
          </Wrapper>
        </Section>
      ) : (
        <SignupSetupPayment
          formData={formData}
          setFormData={setFormData}
          hasSubmitted={hasSubmitted}
          setHasSubmitted={setHasSubmitted}
          generalError={generalError}
          setGeneralError={setGeneralError}
          handleSubmit={handleSubmit}
          handleSkip={handleSkip}
          isSubmitting={isSubmitting}
          streetAddressRef={streetAddressRef}
          postalCodeRef={postalCodeRef}
          fieldErrors={fieldErrors}
          setFieldErrors={setFieldErrors}
          handleInputChange={handleInputChange}
          recaptchaRef={recaptchaRef}
          recaptchaToken={recaptchaToken}
          setRecaptchaToken={setRecaptchaToken}
        />
      )}

      <GenericModal
        isOpen={isModalOpen}
        onClose={() => {
          closeModal();
        }}
      >
        <ModalSignupreferrerindiviualone
          isOpen={isModalOpen}
          onClose={() => {
            closeModal();
          }}
        />
      </GenericModal>

      <GenericModal
        isOpen={openDuplicateEmailModal}
        onClose={() => {
          setOpenDuplicateEmailModal(false);
          window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
        }}
      >
        <ModalSignupreferrerindiviualthree
          isOpen={openDuplicateEmailModal}
          onClose={() => {
            setOpenDuplicateEmailModal(false);
            window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
          }}
          email={formData.email_address}
        />
      </GenericModal>

      <GenericModal
        isOpen={openSuccessModal}
        onClose={() => {
          setOpenSuccessModal(false);
          window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
        }}
      >
        <AccountSuccessModal
          isOpen={openSuccessModal}
          onClose={() => {
            setOpenSuccessModal(false);
            window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
          }}
        />
      </GenericModal>
    </RootWrapperSignupReferrerIndiviual>
  );
}
